import fetch from '@/utils/fetch'


export const tableUrl = '/lottery/cny/winning/list'

// 导出中奖记录
export function exportWinningRecord(query) {
  return fetch( {
    url:'/lottery/cny/winning/list',
    method:'get',
    params:query
  })
}

// 获取可用物流公司
export function getLogisticsList() {
  return fetch( {
    url:'/trade/logistics/list',
    method:'get'
  })
}

// 提交物流信息
export function lotteryCnyWinningExpress(data) {
  return fetch({
    url: '/lottery/cny/winning/express',
    method: 'post',
    data
  })
}
